import { Injectable } from "@angular/core";
import { HateoasResourceOperation } from "@lagoshny/ngx-hateoas-client";
import { Ticket } from "@app/models/rest/ticket";

@Injectable({
  providedIn: "root"
})
export class TicketRestService extends HateoasResourceOperation<Ticket> {
  constructor() {
    super(Ticket);
  }
}
